export enum AFE {
    Included = 1,
    Excluded
}
